import { Injectable } from "@angular/core";

@Injectable()
export class RememberService {
  private storage = window.localStorage;

  constructor() {
    this.forgetPrefixes();
  }

  public get(key: string, defaultValue?: boolean | string) {
    if (this.storage.getItem(this.storageKey(key)) == null) {
      return defaultValue;
    }

    const item = this.storage.getItem(this.storageKey(key));
    return this.parseValue(item);
  }

  public set(key: string, value: boolean | number | string) {
    return this.storage.setItem(this.storageKey(key), String(value));
  }

  public setWithExpiry(key: string, value: boolean | number | string, ttl: number) {
    const now = new Date()

    const item = {
      value: value,
      expiry: now.getTime() + ttl,
    }
    this.storage.setItem(this.storageKey(key), JSON.stringify(item))
  }

  public getWithExpiry(key: string) {
    const itemStr = this.storage.getItem(this.storageKey(key))
    if (!itemStr) {
      return null
    }

    const item = JSON.parse(itemStr)
    const now = new Date()

    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
      // If the item is expired, delete the item from storage
      // and return null
      this.storage.removeItem(this.storageKey(key))
      return null
    }

    return this.parseValue(item.value);
  }

  // Usage:
  //   forget(''): forgets all remember.* items
  //   forget('alerts.'): forgets all remember.alerts.* items
  public forget(prefix: string) {
    for (const key in this.storage) {
      if (key.startsWith(`remember.${prefix}`)) {
        this.storage.removeItem(key);
      }
    }
  }

  private parseValue(val: any) {
    switch (val) {
      case "true":
        return true;
      case "false":
        return false;
      default:
        return val;
    }
  }

  private storageKey(key: string) {
    return `remember.${key}`;
  }

  private forgetPrefixes() {
    // This allows the Rails app to specify which prefs to forget on login.
    // Should be a JSON stringified array of prefixes to forget, e.g. to forget
    // all alerts and color preferences, use something like:
    //   `localStorage.setItem('remember.forget', JSON.stringify(['alerts.', 'colors.']))`
    if (!this.get("forget")) {
      return;
    }
    const prefixes = JSON.parse(this.get("forget").toString());
    prefixes.push("forget");
    for (const prefix of prefixes) {
      this.forget(prefix);
    }
  }
}
